<template>
  <v-container>
    <v-layout text-xs-center wrap>
      <v-flex mb-5 xs12>
        <h1>{{ $t("login_form.please_login") }}</h1>
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-text-field
            id="email"
            v-model="email"
            :rules="emailRules"
            :placeholder="$t('login_form.email')"
            v-on:keyup.enter="focus('password')"
            solo
            required
          ></v-text-field>
          <v-text-field
            id="password"
            v-model="password"
            type="password"
            :rules="passwordRules"
            :placeholder="$t('login_form.password')"
            v-on:keyup.enter="login"
            solo
            required
          ></v-text-field>
          <v-alert :value="loginError" color="error" icon="warning" outline>
            {{
            $t("login_form.wrong_creditentials")
            }}
          </v-alert>
          <v-btn :disabled="!valid" color="success" @click="login">
            {{
            $t("login_form.login")
            }}
          </v-btn>
        </v-form>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import User from "@/models/User.js";
import StatusName from "@/models/StatusName.js";
import StatusRight from "@/models/StatusRight.js";
export default {
  data() {
    return {
      valid: true,
      loginError: false,
      email: "",
      emailRules: [
        (v) => !!v || this.$t("login_form.email_required"),
        (v) => /.+@.+/.test(v) || this.$t("login_form.valid_email_required"),
      ],
      password: "",
      passwordRules: [(v) => !!v || this.$t("login_form.password_required")],
      user: null,
    };
  },
  mounted() {
    this.focus("email");
  },
  methods: {
    login() {
      if (this.valid == true && this.name != "" && this.email != "") {
        this.valid = false;
        this.loginError = false;
        this.getToken();
      } else {
        this.$refs.form.validate();
      }
    },

    focus(elementId) {
      document.getElementById(elementId).focus();
    },

    validate() {
      if (this.$refs.form.validate()) {
        this.snackbar = true;
      }
    },

    async getToken() {
      const login = await User.login(this.email, this.password);
      if (login.status == 200) {
        this.$session.set("jwt", login.data);
        sessionStorage.setItem("jwt", login.data);
        this.userObj = new User(login.data);
        this.getUser();
      } else {
        if (login.status == 401) {
          this.password = "";
          this.loginError = true;
          this.valid = true;
          this.focus("password");
        }
        if (login.status == 400) {
          this.email = "";
          this.password = "";
          this.loginError = true;
          this.valid = true;
          this.focus("email");
        }
      }
    },

    async getUser() {
      const user = await User.loadMe();
      this.$session.set(
        "allow_custom_pallets",
        user.company.allow_custom_pallets
      );

      sessionStorage.setItem(
        "allow_custom_pallets",
        user.company.allow_custom_pallets
      );

      this.user = user;
      this.$session.set("user", user);
      sessionStorage.setItem("user", user);
      await this.getStatusNames();
      await this.getStatusRights();
      this.redirectUser(this.user.type);
    },

    /**
     * gets all the status names for this table in the given language
     */
    async getStatusNames() {
      const statusNames = await StatusName.loadStatusNames({
        params: {
          language: this.$i18n.locale,
        },
      });
      this.$session.set("statusNames", statusNames);
    },

    /**
     * gets all the status rights for this user
     */
    async getStatusRights() {
      const statusRights = await StatusRight.loadStatusRights();
      this.$session.set("statusRights", statusRights);
    },

    redirectUser(type) {
      if (this.user.company_id === 9) {
        this.$router.push({ name: "glass-units" }).catch(() => {});
        return;
      }
      if (window.innerWidth <= 500 && window.innerHeight <= 900) {
        this.$router.push({ name: "scanner" }).catch(() => {});
        return 0;
      }
      const ordersPath = {
        path: `/${this.$router.currentRoute.params.lang}/orders/null/null/null/0/100/50/1/null/false`
      };
      switch (type) {
        case 0:
          this.$router.push(ordersPath).catch(() => {});
          break;
        case 1:
          this.$router.push(ordersPath).catch(() => {});
          break;
        default:
          this.$router.push(ordersPath).catch(() => {});
      }
    },
  },
};
</script>

<style></style>
